var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35.117,
    height: 35.008,
    viewBox: "0 0 35.117 35.008",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#563A96",
    stroke: "#563A96",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M38.1 36.04l-9.455-9.54a13.476 13.476 0 1 0-2.045 2.067l9.394 9.483a1.455 1.455 0 0 0 2.054.053 1.465 1.465 0 0 0 .052-2.063zm-20.044-7.358a10.641 10.641 0 1 1 7.526-3.117 10.575 10.575 0 0 1-7.526 3.117z",
    transform: "translate(-4 -3.993)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/searchIcon.9d4b25228fbdd9af3611062d0ac7eb42.svg";
export { ForwardRef as ReactComponent };